var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Dashboard" } } },
                      [
                        _c(
                          "b-button",
                          { attrs: { size: "sm", variant: "outline-danger" } },
                          [_vm._v(_vm._s(_vm.$t("header.cancel")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          id: "submitButton",
                          size: "sm",
                          variant: "success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.save()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("header.save")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "FromWarehouseId",
                        error: _vm.$v.form.FromWarehouseId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.FromWarehouseId,
                          url:
                            "VisionNextWarehouse/api/Warehouse/AutoCompleteSearch",
                          "dynamic-and-condition": {
                            StatusIds: [1],
                            IsVehicle: 0
                          }
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType(
                              "FromWarehouseId",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.warehouse,
                          callback: function($$v) {
                            _vm.warehouse = $$v
                          },
                          expression: "warehouse"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "RouteId",
                        error: _vm.$v.form.RouteId
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.RouteId,
                          url: "VisionNextRoute/api/Route/AutoCompleteSearch",
                          "dynamic-and-condition": { StatusIds: [1] },
                          "order-by-columns": [
                            { Column: "Description1", OrderByType: 0 }
                          ],
                          "page-count": 500
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType("RouteId", $event)
                          }
                        },
                        model: {
                          value: _vm.route,
                          callback: function($$v) {
                            _vm.route = $$v
                          },
                          expression: "route"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: { "item-key": "IsDone", error: _vm.$v.form.IsDone }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.IsDone,
                          url:
                            "VisionNextStockManagement/api/VanLoadingStatu/Search"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType("IsDone", $event)
                          }
                        },
                        model: {
                          value: _vm.selectedDone,
                          callback: function($$v) {
                            _vm.selectedDone = $$v
                          },
                          expression: "selectedDone"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "LoadingDate",
                        error: _vm.$v.form.LoadingDate
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.LoadingDate },
                        model: {
                          value: _vm.form.LoadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LoadingDate", $$v)
                          },
                          expression: "form.LoadingDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Canceled",
                        error: _vm.$v.form.Canceled,
                        md: "2"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          disabled: _vm.insertReadonly.Canceled,
                          type: "number",
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.Canceled,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Canceled", $$v)
                          },
                          expression: "form.Canceled"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.vanLoading.items"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.items"),
                            error: _vm.$v.vanLoadingItem.Item
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled:
                                !_vm.form.FromWarehouseId ||
                                !_vm.form.RouteId ||
                                !_vm.form.LoadingDate,
                              url: "VisionNextItem/api/Item/AutoCompleteSearch",
                              label: "Description1",
                              "dynamic-and-condition": {
                                StatusIds: [1],
                                CardTypeIds: [1, 2, 8]
                              },
                              searchable: ""
                            },
                            on: { input: _vm.selectedItem },
                            model: {
                              value: _vm.vanLoadingItem.Item,
                              callback: function($$v) {
                                _vm.$set(_vm.vanLoadingItem, "Item", $$v)
                              },
                              expression: "vanLoadingItem.Item"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.vanLoading.FromWhStockQuantity"
                            )
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.FromWhStockQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "FromWhStockQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.FromWhStockQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.ToWhStockQuantity")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.ToWhStockQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "ToWhStockQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.ToWhStockQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.vanLoading.AverageSalesQuantity"
                            )
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.AverageSalesQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "AverageSalesQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.AverageSalesQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.LastSalesQuantity")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.LastSalesQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "LastSalesQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.LastSalesQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.vanLoading.LastdaySalesQuantity"
                            )
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.LastdaySalesQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "LastdaySalesQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.LastdaySalesQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.SuggestedQuantity")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.vanLoadingItem.SuggestedQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "SuggestedQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.SuggestedQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.vanLoading.LoadingQuantity"),
                            required: true,
                            error: _vm.$v.vanLoadingItem.LoadingQuantity
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { min: "1", type: "number" },
                            on: {
                              keypress: function($event) {
                                return _vm.onlyForCurrencyDot($event)
                              }
                            },
                            model: {
                              value: _vm.vanLoadingItem.LoadingQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.vanLoadingItem,
                                  "LoadingQuantity",
                                  $$v
                                )
                              },
                              expression: "vanLoadingItem.LoadingQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right ml-auto",
                          attrs: { cols: "12", md: "3" }
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t("insert.vanLoading.items"),
                                "label-class": "v-none"
                              }
                            },
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addItem()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-table-simple",
                            {
                              attrs: { responsive: "", bordered: "", small: "" }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("insert.vanLoading.items")
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.FromWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.ToWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.AverageSalesQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.LastSalesQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.LastdaySalesQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.SuggestedQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.vanLoading.LoadingQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(
                                  _vm.form.VanLoadingItems
                                    ? _vm.form.VanLoadingItems.filter(function(
                                        i
                                      ) {
                                        return i.RecordState !== 4
                                      })
                                    : [],
                                  function(r, i) {
                                    return _c(
                                      "b-tr",
                                      { key: i },
                                      [
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.Description1))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.FromWhStockQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.ToWhStockQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.AverageSalesQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.LastSalesQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.LastdaySalesQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.SuggestedQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.LoadingQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-edit text-warning",
                                              on: {
                                                click: function($event) {
                                                  return _vm.editVanLoadingItems(
                                                    r
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("i", {
                                              staticClass:
                                                "far fa-trash-alt text-danger",
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeVanLoadingItems(
                                                    r
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ef4b98b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ef4b98b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/VanLoading/update.vue
// module id = null
// module chunks = 